var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 56,
    viewBox: "0 0 45 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 0H5.625C2.51587 0 0 2.50469 0 5.6V50.4C0 53.4953 2.51587 56 5.625 56H39.375C42.4841 56 45 53.4953 45 50.4V16.8L28.125 0ZM14.0625 50.4H8.4375V44.8H14.0625V50.4ZM14.0625 42H8.4375V36.4H14.0625V42ZM14.0625 33.6H8.4375V28H14.0625V33.6ZM36.5625 50.4H19.6875V44.8H36.5625V50.4ZM36.5625 42H19.6875V36.4H36.5625V42ZM36.5625 33.6H19.6875V28H36.5625V33.6ZM25.3125 19.6V4.2L40.7812 19.6H25.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.4769c00b6d0e83cd1d35b3733bf9f940.svg";
export { ForwardRef as ReactComponent };